// src/components/garantias/CrearGarantia.js
import React, { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import { useAuth } from '../../context/AuthContext';
import { createGarantia, /* uploadImages, */ generatePDF, savePDF } from '../../api/authgarantia';

// ================= BASE DE API (prod => mismo origin; dev => localhost:3000) =================
const API_BASE =
  (process.env.REACT_APP_API_URL &&
    process.env.REACT_APP_API_URL.replace(/\/+$/, '')) ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : window.location.origin);

// ================= Catálogos / listas =================
const OPCIONES_GARANTIA = [
  'CUERDAS EXPUESTAS EN INNERLINER / EXPOSED CORDS IN INNERLINER',
  'BANDAS O CONJUNTO DE CUERDAS DEMASIADO AMPLIO EN EL PROCESO DE MANUFACTURA (TASLAPE) / BELT OR CORD OVERLAP',
  'SEPARACIÓN DE COMPONENTES (CONTAMINACIÓN EN INNERLINER POR MATERIALES EXTRAÑOS EN LLANTA) FALTA ADHESIÓN/ MATERIAL DETACHMENT DUE TO CONTAMINATION OF COMPONENTS',
  'ALAMBRES SUELTOS O SEPARADOS DE LA CEJA (TALÓN) O CUERPO DE LAS CUERDAS (TELAS) CARCASA (AMARRES) / DETACHMENT FROM CORDS OF BEAD, SIDE WALL, INNERLINER, AND OR THREAD WIDTH.',
  'DAÑOS POR TRANSPORTACIÓN (OCASIONADO DURANTE EL EMBARQUE Y MANEJO) / TRANSPORTATION DAMAGE',
  'BURBUJAS, AMPOLLAS Y SEPARACIÓN DE REFUERZO EN CEJA (TALÓN) EXTERIOR/ EXTERNAL OR INTERNAL BLISTERS',
  'PERDIDA DE ADHESIÓN ENTRE HULE (GOMA) DE LA BANDA DE RODAMIENTO Y EL CINTURON ESTABILIZADOR/ LACK OF ADHESION BETWEEN BELTS AND THREAD WIDTH.',
  'BANDA DE RODAMIENTO DESVASTADA -LAMINACIÓN- DESPRENDIDA / THREAD REDUCTION - LAMINATION OR DETACHMENT.',
  'BANDA O CONJUNTO DE CUERDAS CORTO EN PROCESO DE MANUFACTURA / MISSING CORDS SEGMENT',
  'PERDIDA DE ADHESION DENTRO DE NEUMATICO, EN LA UNION DEL PAQUETE DE CINTURONES (ESTABILIZADORES) HOMBRO. / ADHESION LOST AND DETACHMENT BETWEEN BELTS AND SHOULDER.',
  'FALTA DE TEMPERATURA EN PROCESO DE NEUMÁTICO (DESGASTE RÁPIDO GENERALIZADO).  UNEVEN AND OR ACCELERATED WEAR.',
  'FLUJO INADECUADO DEL HULE (GOMA) DURANTE EL PROCESO DE MANUFACTURA / INADEQUATE RUBBER FLOW DURING THE MANUFACTURING PROCESS.',
  'ESPACIAMIENTO MÁS AMPLIO DE LO NORMAL EN LA COLOCACIÓN DE LOS CABLES / WIDER GAPS THAN ACCEPTED BETWEEN CORDS.'
];

const PROVEEDORSELECT = [
  "JK TORNEL, S.A DE C.V",
  "CONTINENTAL TIRE DE MÉXICO, S.A DE C.V.",
  "INDUSTRIAS DE HULE GALGO, S.A DE C.V",
  "SUNSET TIRES CORPORATION LIMITED",
  "HUASHENG RUBBER CO., LIMITED",
  "GOODYEAR SERVICIOS COMERCIALES SA DE CV",
  "Z TYRES, S.A DE C.V",
  "H2 TITAN S.A. DE C.V.",
  "GOLDEN HORSE RUBBER SDN BHD",
  "CONTRAPESOS Y ACCESORIOS RYS SA DE CV",
  "EVERTHROUGH RUBBER PRODUCTOS",
  "JIAXING YOURUN TECH. CO., LTD",
  "SHANDONG WIDEWAY TIRE CO., LTD",
  "ZHEJIANG RONGPENG IMP & EXP. CO., LTD",
  "ZODO TIRE CO., LIMITED",
  "ALWIN INDUSTRIAL CO., LIMITED",
  "WEIFANG GOLDSHIELD TIRE CO., LTD",
  "HAOHUA TIRE CO., LIMITED",
  "SHANDONG LUQI MACHINERY CO., LTD",
  "LUBAO INT'L INDUSTRY CO., LIMITED",
  "SHANDONG CHANGFENG TYRES CO., LTD",
  "SHANDONG FENGYUAN TIRE MANUFACTURING CO., LTD",
  "LLIT (THAILAND) CO., LTD.",
  "HENAN HENGSAIER AUTO PARTS CO., LTD.",
  "SHANDONG HENGFENG RUBBER AND PLASTIC CO., LTD.",
  "SHANGHAI XIAYU INTERNATIONAL TRADING CO., LTD",
  "NINGBO TIANYI SHAFT CO., LTD",
  "WEIFANG AIRUI BRAKE SYSTEMS CO., LTD",
  "QINGDAO TAIHAO TYRE CO., LTD",
  "QINGDAO QIHANG TYRE CO., LTD",
  "QINGDAO HUASHENG RUBBER CO., LTD",
  "WEIHAI JIAHANG RUBBER TECHNOLOGY CO., LTD.",
  "XIAMEN ITG MATERIALS CO., LTD",
  "MNA INDUSTRIAL LIMITED",
  "WENDENG SANFENG TIRE CO., LTD",
  "KEERUN TIRE (DEZHOU) CO., LTD",
  "SHANDONG LINGLONG TYRE CO., LTD",
  "SHANDONG PROVINCE SANLI TIRE MANUFACTURE CO., LTD",
  "NINGBO JUNDA IMPORT Y EXPORT CO., LTD.",
  "NOVAMAXX INDUSTRY CO., LIMITED",
  "XINGMIN INTELLIGENT TRANSPORTATION SYSTEMS GROUP CO., LTD"
];

const STATUS_GARANTIA = [ 'EN PROCESO', 'VALIDANDO', 'APROBADA', 'RECHAZADA', 'EN REVISIÓN' ];

function generarFolio() {
  return 'GAR-' + Date.now();
}

// ================= PDF =================
const generatePDFFromGarantiaData = async (garantiaData) => {
  const garantia = garantiaData.garantia;
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const drawHeader = async () => {
    doc.setFontSize(10);
    doc.text(`WARRANTY CLAIM ${garantia.numFolio || ''}`, 40, 36);
    try {
      const img = new window.Image();
      img.src = process.env.PUBLIC_URL + '/logo.png';
      await new Promise((resolve) => { img.onload = resolve; });
      doc.addImage(img, 'PNG', pageWidth - 120, 10, 80, 80);
    } catch { /* noop */ }
  };

  await drawHeader();
  doc.setFontSize(16);
  doc.text('Warranty Claim Report', pageWidth / 2, 70, { align: 'center' });

  doc.setFontSize(10);
  const marginX = 32;
  const marginY = 90;
  const tableWidth = pageWidth - marginX * 2;
  const tableHeight = pageHeight - marginY - 60;
  const labelWidth = tableWidth * 0.35;
  const valueWidth = tableWidth - labelWidth;

  const normalRows = [
    ['DATE – FECHA CREACION', new Date(garantia.fechaCreacion).toLocaleDateString('es-MX') || ''],
    ['BRAND - MARCA', garantia.marca || ''],
    ['INVOICE – FACTURA', garantia.factura || ''],
    ['DATE INVOICE – FECHA FACTURA', garantia.fechaFactura || ''],
    ['SKU - PRODUCTO', garantia.producto || ''],
    ['PROVIDER - PROVEEDOR', garantia.proveedor || ''],
    ['SERIES NUM. – NUM SERIE', garantia.numSerie || ''],
    ['PLANT DOT - DOT PRODUCCION', garantia.dotProduccion || ''],
    ['PRODUCTION DOT: DOT FABRICACION', garantia.dotFabricacion || ''],
    ['MM REMAINING FLOOR DEPTH – REMANENTE DE PISO MM', garantia.remantePiso || ''],
    ['PSI INFLATION PRESSURE: PRESION DE INFLADO PSI', garantia.presioInflado || ''],
    ['INSTALLATION DATE – FECHA DE INSTALACION', garantia.fechaInstalacion || ''],
    ['TIME OF USE – TIEMPO DE USO', garantia.tiempoUso || ''],
    ['WARRANTY TYPE – TIPO DE GARANTIA', garantia.tipoGarantia || ''],
  ];

  const descLabel = 'DAMAGE DESCRIPTION – DESCRIPCION DEL DAÑO';
  const descValue = garantia.observaciones || garantia.descripcionDaño || '';
  const rowCount = normalRows.length + 1;
  const rowHeight = Math.floor(tableHeight / rowCount);
  let y = marginY;

  for (let i = 0; i < normalRows.length; i++) {
    doc.rect(marginX, y, labelWidth, rowHeight);
    const labelLines = doc.splitTextToSize(normalRows[i][0], labelWidth - 12);
    doc.text(labelLines, marginX + 8, y + 16, { maxWidth: labelWidth - 12 });

    doc.rect(marginX + labelWidth, y, valueWidth, rowHeight);
    const valueLines = doc.splitTextToSize(normalRows[i][1], valueWidth - 12);
    doc.text(valueLines, marginX + labelWidth + 8, y + 16, { maxWidth: valueWidth - 12 });
    y += rowHeight;
  }

  const descRowHeight = tableHeight - rowHeight * (rowCount - 1);
  doc.rect(marginX, y, labelWidth, descRowHeight);
  const descLabelLines = doc.splitTextToSize(descLabel, labelWidth - 12);
  doc.text(descLabelLines, marginX + 8, y + 16, { maxWidth: labelWidth - 12 });

  doc.rect(marginX + labelWidth, y, valueWidth, descRowHeight);
  const splitDesc = doc.splitTextToSize(descValue, valueWidth - 12);
  doc.text(splitDesc, marginX + labelWidth + 8, y + 16, { maxWidth: valueWidth - 12 });

  doc.setFontSize(9);
  doc.text(
    'UPLOADED PICTURES – ANEXO DE FOTOS : *** 1 foto por página para que se vea lo más amplia posible.',
    marginX,
    pageHeight - 24
  );

  if (garantia.imagenes && garantia.imagenes.length > 0) {
    const tipoImagenes = [
      { label: '1. MAIN DAMAGE – DAÑO PRINCIPAL', campo: 'dañoPrincipal' },
      { label: '2. TIRE TREAD – PISO', campo: 'piso' },
      { label: '3. TIRE SIDEWALL – COSTADO', campo: 'costado' },
      { label: '4. SERIES NUMBER – NÚMERO DE SERIE', campo: 'numSerie' },
      { label: '5. DOT FABRICACIÓN', campo: 'dotFabricacion' },
      { label: '6. REMANENTE DE PISO', campo: 'remantePiso' },
      { label: '7. FACTURA', campo: 'factura' }
    ];

    for (const tipo of tipoImagenes) {
      const imagen = garantia.imagenes.find(img => img.campoAsociado === tipo.campo);
      if (imagen) {
        doc.addPage();
        await drawHeader();
        doc.setFontSize(14);
        doc.text(tipo.label, marginX, 60);

        try {
          const img = new window.Image();
          img.crossOrigin = 'anonymous';
          const imageUrl = `${API_BASE}/uploads/certificados/${encodeURIComponent(imagen.nombreArchivo)}`;
          img.src = imageUrl;

          await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            setTimeout(reject, 7000);
          });

          const maxImgW = pageWidth - marginX * 0.5;
          const maxImgH = pageHeight - 100;
          let imgW = maxImgW, imgH = maxImgH;

          const ratio = img.naturalWidth / img.naturalHeight;
          if (imgW / imgH > ratio) {
            imgW = imgH * ratio;
          } else {
            imgH = imgW / ratio;
          }
          const x = (pageWidth - imgW) / 2;
          const yImg = ((pageHeight - imgH) / 2) + 10;

          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/jpeg', 0.85);

          doc.addImage(dataURL, 'JPEG', x, yImg, imgW, imgH);
        } catch (error) {
          doc.setFontSize(10);
          doc.text(`Error al cargar imagen: ${imagen.nombreArchivo}`, marginX, 90);
          doc.text('La imagen puede no estar disponible en el servidor.', marginX, 110);
        }
      }
    }
  }

  return doc.output('datauristring');
};

// ================= UI helpers =================
function SectionTitle({ children }) {
  return <h3 className="text-lg font-semibold text-blue-700 mt-6 mb-2 border-b pb-1">{children}</h3>;
}

// ================= Componente principal =================
function CrearGarantia({ onSuccess }) {
  const auth = useAuth();
  const ctxToken = auth?.token;
  const storedToken =
    localStorage.getItem('token') ||
    sessionStorage.getItem('token') ||
    localStorage.getItem('accessToken') ||
    sessionStorage.getItem('accessToken') ||
    null;
  const token = ctxToken || storedToken || '';

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const [skuDescription, setSkuDescription] = useState('');

  // Estado del formulario
  const [form, setForm] = useState({
    numfolio: generarFolio(),
    fechaCreacion: new Date().toISOString().slice(0, 10),
    marca: '',
    sku: '',
    skudescripcion: '',
    proveedor: '',
    factura: '',
    fechaFactura: '',
    facturaPDF: null,

    producto: '',
    numserie: '',
    numseriePhoto: null,

    dotproduccion: '',
    dotfabricacion: '',
    dotfabricacionPhoto: null,

    remanentepiso: '',
    remanentepisoPhoto: null,

    presioinflado: '',
    fechainstalacion: '',
    tiempouso: '',

    // múltiples
    danoprincipalPhoto: [],
    pisoPhoto: [],
    costadoPhoto: [],

    foliozn: '',
    descripciondano: '',
    selecciongarantia: '',
    status: 'EN PROCESO'
  });

  // Buscar descripción por SKU en inventoryData
  const buscarDescripcionSku = (sku) => {
    if (!sku || sku.trim() === '') {
      setSkuDescription('');
      setForm(prev => ({ ...prev, skudescripcion: '' }));
      return;
    }

    if (!Array.isArray(inventoryData) || inventoryData.length === 0) {
      setSkuDescription('');
      setForm(prev => ({ ...prev, skudescripcion: '' }));
      return;
    }

    const item = inventoryData.find(p =>
      p.internal_sku &&
      p.internal_sku.toUpperCase() === sku.trim().toUpperCase()
    );

    if (item && item.internal_title) {
      setSkuDescription(item.internal_title);
      setForm(prev => ({ ...prev, skudescripcion: item.internal_title }));
    } else {
      setSkuDescription('');
      setForm(prev => ({ ...prev, skudescripcion: '' }));
    }
  };

  // onChange para inputs (con soporte de fotos múltiples)
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    // campos múltiples
    if (['danoprincipalPhoto', 'pisoPhoto', 'costadoPhoto'].includes(name)) {
      const fileArr = files ? Array.from(files).slice(0, 5) : [];
      setForm(prev => ({ ...prev, [name]: fileArr }));
      return;
    }

    setForm(prev => ({ ...prev, [name]: files ? files[0] : value }));

    if (name === 'sku' && !files) {
      // buscar descripción async
      setTimeout(() => buscarDescripcionSku(value), 0);
    }
  };

  // Cargar inventario al montar
  useEffect(() => {
    const cargarInventario = async () => {
      if (!token) {
        console.log('Esperando token de autenticación...');
        return;
      }
      try {
        // SOLUCIÓN: Usar un límite muy alto para asegurar obtener el máximo
        // de registros permitido por el backend (200), en lugar del default (10).
        const res = await fetch(`${API_BASE}/api/inventory?limit=5000`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          credentials: 'include',
        });

        if (!res.ok) {
          const raw = await res.text();
          throw new Error(`Error inventario ${res.status}: ${raw.slice(0, 140)}`);
        }
        const data = await res.json();
        const inventory = data?.inventory || data || [];
        setInventoryData(Array.isArray(inventory) ? inventory : []);
      } catch (err) {
        console.error('❌ Error al cargar inventario:', err);
      }
    };
    cargarInventario();
  }, [token]);

  // Subir imágenes (múltiples por campo) directamente
  async function uploadImagesDirect(numFolio, fieldsMap) {
    const fd = new FormData();
    // Cada key puede ser File o Array<File>
    Object.entries(fieldsMap).forEach(([field, value]) => {
      if (!value) return;
      if (Array.isArray(value)) {
        value.forEach((file) => file && fd.append(field, file));
      } else if (value instanceof File) {
        fd.append(field, value);
      }
    });

    const res = await fetch(`${API_BASE}/api/garantias/upload-images/${encodeURIComponent(numFolio)}`, {
      method: 'POST',
      body: fd,
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: 'include',
    });

    // el backend debe devolver JSON con {ok: true} o similar
    const ct = res.headers.get('content-type') || '';
    const raw = await res.text();
    if (!res.ok) {
      if (ct.includes('application/json')) {
        let j = {};
        try { j = JSON.parse(raw); } catch {}
        throw new Error(j?.mensaje || j?.message || `Error al subir imágenes (${res.status})`);
      }
      throw new Error(`Error al subir imágenes (${res.status}): ${raw.slice(0, 160)}`);
    }
    if (ct.includes('application/json')) {
      try { return JSON.parse(raw); } catch { return {}; }
    }
    return {};
  }

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      // Datos para backend
      const garantiaData = {
        numFolio: form.numfolio,
        marca: form.marca,
        sku: form.sku,
        skuDescripcion: form.skudescripcion,
        factura: form.factura,
        fechaFactura: form.fechaFactura,
        producto: form.sku, // si haces join por SKU
        proveedor: form.proveedor,
        numSerie: form.numserie || '',
        dotProduccion: form.dotproduccion,
        dotFabricacion: form.dotfabricacion,
        remantePiso: form.remanentepiso,
        presioInflado: form.presioinflado,
        fechaInstalacion: form.fechainstalacion,
        tiempoUso: form.tiempouso,
        dañoPrincipal: '', // lo llenan con imagen
        piso: '',
        costado: '',
        descripcionDaño: form.descripciondano,
        tipoGarantia: form.selecciongarantia,
        observaciones: form.descripciondano,
        saldoAFavor: '0',
        estatusSaldo: 'PENDIENTE',
        facturaAplicada: form.factura,
        status: form.status
      };

      // 1) Crear
      await createGarantia(garantiaData);
      const realNumFolio = form.numfolio;

      // 2) Subir imágenes (múltiples por campo)
      const imagesToUpload = {
        numseriePhoto: form.numseriePhoto,
        dotfabricacionPhoto: form.dotfabricacionPhoto,
        remanentepisoPhoto: form.remanentepisoPhoto,
        danoprincipalPhoto: form.danoprincipalPhoto, // arrays soportados
        pisoPhoto: form.pisoPhoto,
        costadoPhoto: form.costadoPhoto,
      };
      await uploadImagesDirect(realNumFolio, imagesToUpload);
      // Si prefieres tu API: await uploadImages(realNumFolio, imagesToUpload);

      // 3) Subir PDF de factura (si hay)
      if (form.facturaPDF) {
        const pdfFormData = new FormData();
        pdfFormData.append('facturaPDF', form.facturaPDF);
        const resp = await fetch(`${API_BASE}/api/garantias/upload-invoice-pdf/${encodeURIComponent(realNumFolio)}`, {
          method: 'POST',
          body: pdfFormData,
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          credentials: 'include',
        });
        if (!resp.ok) {
          const raw = await resp.text();
          console.warn('⚠️ Error al subir factura PDF:', raw);
        }
      }

      // 4) Generar y guardar PDF final
      try {
        const datosGarantia = await generatePDF(realNumFolio);
        const pdfBase64 = await generatePDFFromGarantiaData(datosGarantia);
        await savePDF(realNumFolio, pdfBase64);
      } catch (pdfError) {
        console.error('Error al generar/guardar PDF:', pdfError);
        alert('Garantía creada, pero hubo un problema al generar el PDF. Puedes generarlo manualmente desde la tabla.');
      }

      setSuccess(true);

      // Reset
      setForm({
        numfolio: generarFolio(),
        fechaCreacion: new Date().toISOString().slice(0, 10),
        marca: '',
        sku: '',
        skudescripcion: '',
        proveedor: '',
        factura: '',
        fechaFactura: '',
        facturaPDF: null,

        producto: '',
        numserie: '',
        numseriePhoto: null,

        dotproduccion: '',
        dotfabricacion: '',
        dotfabricacionPhoto: null,

        remanentepiso: '',
        remanentepisoPhoto: null,

        presioinflado: '',
        fechainstalacion: '',
        tiempouso: '',

        danoprincipalPhoto: [],
        pisoPhoto: [],
        costadoPhoto: [],

        foliozn: '',
        descripciondano: '',
        selecciongarantia: '',
        status: 'EN PROCESO',
      });

      // callback al padre
      if (onSuccess) onSuccess();
      alert('¡Garantía creada exitosamente!');
    } catch (err) {
      console.error('❌ Error al crear garantía:', err);
      setError(err.message || 'Error al crear la garantía');
      alert('Error al crear la garantía: ' + (err.message || 'Error desconocido'));
    } finally {
      setLoading(false);
    }
  };

  // ================= Render =================
  return (
    <div className="p-8 max-w-3xl mx-auto bg-white rounded-xl shadow-lg border border-gray-200">
      <h2 className="text-3xl font-bold mb-2 text-blue-800 text-center">Crear Nueva Garantía</h2>
      <p className="text-gray-500 mb-6 text-center">
        Llena el siguiente formulario para registrar una nueva garantía.
      </p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <SectionTitle>Datos Generales</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600">Folio de Garantía</label>
            <input name="numfolio" value={form.numfolio} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Número de SKU</label>
            <input
              name="sku"
              value={form.sku}
              onChange={handleChange}
              className="border rounded px-2 py-1 w-full"
              placeholder="Ingresa el SKU..."
              required
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Descripción del SKU</label>
            <input
              name="skudescripcion"
              value={form.skudescripcion}
              onChange={handleChange}
              className={`border rounded px-2 py-1 w-full ${
                skuDescription ? 'bg-blue-50 border-blue-300 text-blue-800' : 'bg-white border-gray-300'
              }`}
              placeholder={skuDescription ? 'Descripción automática desde inventario' : 'Descripción del SKU'}
              disabled={!!skuDescription}
              required
            />
            {skuDescription && (
              <div className="mt-1 text-xs text-blue-600">
                📦 Descripción cargada automáticamente. Borre el SKU para editar manualmente.
              </div>
            )}
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Proveedor</label>
            <select name="proveedor" value={form.proveedor} onChange={handleChange} className="border rounded px-2 py-1 w-full" required>
              <option value="">Selecciona un proveedor</option>
              {PROVEEDORSELECT.map((p, i) => (
                <option key={i} value={p}>{p}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Fecha de Creación</label>
            <input type="date" name="fechaCreacion" value={form.fechaCreacion} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Marca</label>
            <input name="marca" value={form.marca} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Factura</label>
            <input name="factura" value={form.factura} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Fecha de Factura</label>
            <input type="date" name="fechaFactura" value={form.fechaFactura} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Factura PDF</label>
            <input type="file" name="facturaPDF" accept="application/pdf" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" required />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Producto</label>
            <input name="producto" value={form.producto} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
        </div>

        <SectionTitle>Identificación y DOT</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600">Número de Serie</label>
            <input name="numserie" value={form.numserie} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">Foto Número de Serie</label>
            <input type="file" name="numseriePhoto" accept="image/*" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" required />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">DOT Producción</label>
            <input name="dotproduccion" value={form.dotproduccion} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
         
          <div>
            <label className="block text-xs font-semibold text-gray-600">Foto DOT Fabricación</label>
            <input type="file" name="dotfabricacionPhoto" accept="image/*" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" required />
          </div>
        </div>

        <SectionTitle>Condición del Piso</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600">Remanente Piso</label>
            <input name="remanentepiso" value={form.remanentepiso} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">Foto Remanente Piso</label>
            <input type="file" name="remanentepisoPhoto" accept="image/*" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" required />
          </div>
        </div>

        <SectionTitle>Instalación y Uso</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600">Presión Inflado</label>
            <input name="presioinflado" value={form.presioinflado} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">Fecha Instalación</label>
            <input type="date" name="fechainstalacion" value={form.fechainstalacion} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">Tiempo de Uso</label>
            <input name="tiempouso" value={form.tiempouso} onChange={handleChange} className="border rounded px-2 py-1 w-full" required />
          </div>
        </div>

        <SectionTitle>Fotos de Daños</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600">Foto Daño Principal (máx. 5)</label>
            <input type="file" name="danoprincipalPhoto" accept="image/*" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" multiple />
            {form.danoprincipalPhoto?.length > 0 && (
              <div className="text-xs text-gray-500 mt-1">{form.danoprincipalPhoto.length} archivo(s) seleccionado(s)</div>
            )}
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">Foto Piso (máx. 5)</label>
            <input type="file" name="pisoPhoto" accept="image/*" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" multiple />
            {form.pisoPhoto?.length > 0 && (
              <div className="text-xs text-gray-500 mt-1">{form.pisoPhoto.length} archivo(s) seleccionado(s)</div>
            )}
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-600">Foto Costado (máx. 5)</label>
            <input type="file" name="costadoPhoto" accept="image/*" onChange={handleChange} className="border rounded px-2 py-1 w-full bg-white" multiple />
            {form.costadoPhoto?.length > 0 && (
              <div className="text-xs text-gray-500 mt-1">{form.costadoPhoto.length} archivo(s) seleccionado(s)</div>
            )}
          </div>
        </div>

        <SectionTitle>Detalles de Daño y Garantía</SectionTitle>
        <div className="mb-2">
          <label className="block text-xs font-semibold text-gray-600">Descripción del Daño</label>
          <textarea
            name="descripciondano"
            value={form.descripciondano}
            onChange={handleChange}
            className="border rounded px-2 py-1 w-full min-h-[60px]"
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-semibold text-gray-600">Tipo de Garantía</label>
            <select
              name="selecciongarantia"
              value={form.selecciongarantia}
              onChange={handleChange}
              className="border rounded px-2 py-1 w-full bg-white"
              required
            >
              <option value="">Selecciona una opción</option>
              {OPCIONES_GARANTIA.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-600">Status de Garantía</label>
            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              className="border rounded px-2 py-1 w-full bg-white"
              required
            >
              {STATUS_GARANTIA.map(status => <option key={status} value={status}>{status}</option>)}
            </select>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-end pt-4 gap-2">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-2">
              {error}
            </div>
          )}
          {success && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded mb-2">
              ¡Garantía creada exitosamente!
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className={`${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-700 hover:bg-blue-800'} transition text-white px-8 py-2 rounded font-semibold shadow`}
          >
            {loading ? 'Guardando...' : 'Guardar Garantía'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CrearGarantia;